<template>
  <div>
    <v-combobox
      persistent-hint
      small-chips
      v-model="dataPost[fieldName?fieldName.name:dataField.name]"
      :label="dataField.title ? dataField.title : ''"
      :items="dataField.choices ? dataField.choices : []"
      item-text="value"
      :multiple="dataField.params.multiple ? dataField.params.multiple : false"
      :background-color="
        alerts[dataField.name] ? 'red lighten-4' : 'grey lighten-5'
      "
      :rules="dataField.params.required ? required : null"
      @change="alerts[dataField.name] = null"
 :error="alerts[dataField.name] != null"
      :error-messages="alerts[dataField.name]"
    ></v-combobox>
  </div>
</template>
<script>
export default {
  name: "ComboBox",
  props: ["dataField","fieldName"],
  computed: {
    dataPost: {
      get() {
        this.$store.commit("updateDataPost", this.$store.state.dataPost);
        return this.$store.state.dataPost;
      },
    },
    alerts: {
      get() {
        return this.$store.state.alerts;
      },
    },
  },
  data: () => ({
    required: [(v) => !!v || "اجباری می باشد"],
  }),
};
</script>
